/**
 * Sidebar navigation component.
 */

import { Link, useLocation } from 'react-router-dom';
import {
  LayoutDashboard,
  Link as LinkIcon,
  Globe,
  BarChart3,
  Users,
  CreditCard,
  Settings,
} from 'lucide-react';
import { cn } from '@/utils/cn';
import './sidebar.scss';

const navigation = [
  { name: 'Dashboard', href: '/dashboard', icon: LayoutDashboard },
  { name: 'Placements', href: '/placements', icon: LinkIcon },
  { name: 'Domains', href: '/domains', icon: Globe },
  { name: 'Reports', href: '/reports', icon: BarChart3 },
  { name: 'Organization', href: '/org', icon: Users },
  { name: 'Billing', href: '/billing', icon: CreditCard },
  { name: 'Settings', href: '/settings', icon: Settings },
];

export function Sidebar() {
  const location = useLocation();

  return (
    <div className="sidebar">
      <div className="sidebar__header">
        <h1 className="sidebar__brand">Origyns</h1>
      </div>
      <nav className="sidebar__nav">
        {navigation.map((item) => {
          const isActive = location.pathname.startsWith(item.href);
          return (
            <Link
              key={item.name}
              to={item.href}
              className={cn('sidebar__nav-item', {
                'sidebar__nav-item--active': isActive,
              })}
            >
              <item.icon />
              {item.name}
            </Link>
          );
        })}
      </nav>
    </div>
  );
}

